export const config = {
  GRAPHQL_URL: process.env.GRAPHQL_URL,
  GRAPHQL_SUBSCRIPTION_URL: process.env.GRAPHQL_SUBSCRIPTION_URL,
}